/* eslint-disable */

import { OrderMapper } from "../../order/mapper";

export const BranchOrderMapper = {
  hydrate: (data) => OrderMapper.hydrate(data),
};
